import React from 'react';
import { Paper, Grid, InputLabel, Typography, Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  progress: {
    color: theme.palette.background.paper
  },
  label: {
    fontSize: '12px'
  },
  field: {
    fontSize: '14px'
  }
}));

const providerColumns = [
  {
    title: 'Customers',
    field: 'participantType',
    type: 'string'
  },
  {
    title: 'Providers',
    field: 'participantType',
    type: 'string'
  }
];

interface ServiceHeaderProps {
  providerData: providerInfo;
  data: serviceInfo;
}
type providerInfo = {
  [key: string]: any;
};

type serviceInfo = {
  [key: string]: any;
};

const ServiceHeader = (props: ServiceHeaderProps) => {
  const classes = useStyles();
  let { providerData, data } = props;
  return (
    <Paper variant="outlined">
      <Box p={2}>
        <Grid container spacing={2}>
          {Object.keys(providerData).length !== 0 &&
            providerColumns.map(({ title, field, type }) => (
              <Grid key={title} item sm={3}>
                <InputLabel className={classes.label}>{title}</InputLabel>
                <Typography className={classes.field}>
                  {title === 'Customers' ? data.serviceInfo.length : providerData.providerInfo.length}
                </Typography>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default ServiceHeader;
